define([
    'common/modules/experiments/tests/generic-email-variants'
], function (
    genericEmailTest
) {
    return new genericEmailTest(
        {
            id: 'FashionStatementEmailVariants',
            start: '2017-03-14',
            end: '2017-03-31',
            author: 'David Furey',
            audience: 0,
            audienceOffset: 0,
            canonicalListId: 105,
            testIds: [
                { variantId: 'control', listId: 3863 },
                { variantId: 'variant', listId: 3862 }
            ]
        }
    );
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/common/modules/experiments/tests/fashion-statement-email-variants.js
// module id = 335
// module chunks = 0 15